import hoistNonReactStatics from 'hoist-non-react-statics';
import PropTypes from 'prop-types';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import withLogger from './withLogger';
import FallbackComponent from '../FallbackComponent/_FallbackComponent';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            correlationId: null,
        };
    }

    componentDidCatch(error) {
        const { logger, componentName } = this.props;
        const correlationId = uuidv4();
        this.setState({
            error,
            correlationId,
        });
        logger.error(error.message, { componentName, correlationId });
    }

    render() {
        const {
            children,
            componentCssBlock,
            useFullWidth,
            useSmallViewportBreakpoints,
        } = this.props;

        if (this.state.error && componentCssBlock === 'sapcnqr-app-translation-tool') {
            return null;
        }

        if (this.state.error && componentCssBlock !== 'sapcnqr-app-idle-timer') {
            return (
                <FallbackComponent
                    componentCssBlock={componentCssBlock}
                    correlationId={this.state.correlationId}
                    useFullWidth={useFullWidth}
                    useSmallViewportBreakpoints={useSmallViewportBreakpoints}
                />
            );
        }
        return children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.any,
    componentCssBlock: PropTypes.string,
    componentName: PropTypes.string,
    useFullWidth: PropTypes.bool,
    useSmallViewportBreakpoints: PropTypes.bool,
};

const ErrorBoundaryWithLogger = withLogger(ErrorBoundary);

export default (Component) => {
    const name = Component.displayName || Component.name;

    const Wrapped = (props) => {
        /* eslint-disable react/prop-types */
        const {
            useFullWidth,
            useSmallViewportBreakpoints,
        } = props;
        /* eslint-enable react/prop-types */

        return (
            <ErrorBoundaryWithLogger
                componentCssBlock={Component.cssBlock}
                componentName={name}
                useFullWidth={useFullWidth}
                useSmallViewportBreakpoints={useSmallViewportBreakpoints}
            >
                <Component {...props} />
            </ErrorBoundaryWithLogger>
        );
    };

    hoistNonReactStatics(Wrapped, Component);
    Wrapped.displayName = name ? `withErrorBoundary(${name})` : 'withErrorBoundary';

    return Wrapped;
};
